import React from "react";
import TrackVisibility from "react-on-screen";

import fullStackIcon from "../../assets/icons/3d-layers.png";
import aiIcon from "../../assets/icons/3d-ai.png";
import paymentIcon from "../../assets/icons/3d-bank-cards.png";
import cloudDbIcon from "../../assets/icons/3d-data-config.png";
import leadershipIcon from "../../assets/icons/3d-group.png";
import uiUxIcon from "../../assets/icons/3d-web-design.png";

const servicesData = [
  {
    icon: <img src={fullStackIcon} alt="Full-Stack Web Architecture" />,
    name: "Full-Stack Web Architecture",
    content: "Architecting end-to-end web applications with React, Next.js, Node.js, Express, and .NET Core. Building scalable component hierarchies, clean RESTful APIs, and robust backend systems engineered for high-performance production workloads."
  },
  {
    icon: <img src={aiIcon} alt="AI & Agentic Workflows" />,
    name: "AI & Agentic Workflows",
    content: "Integrating cutting-edge AI coding agents (Google Antigravity, Cursor) and automated n8n workflows into production engineering. Accelerating development velocity, automating workflows, and leveraging modern LLM capabilities."
  },
  {
    icon: <img src={paymentIcon} alt="Payment Gateways & Integrations" />,
    name: "Payment Gateways & APIs",
    content: "Implementing enterprise-grade payment flows using Razorpay, Cashfree, and Stripe. Engineering secure webhook verification, automated transaction reconciliation, and seamless checkout experiences."
  },
  {
    icon: <img src={cloudDbIcon} alt="Cloud & Database Engineering" />,
    name: "Cloud & Database Systems",
    content: "Designing efficient database schemas across MongoDB, MS-SQL, MySQL, and Supabase. Deploying and managing optimized cloud infrastructure on Vercel and VPS Linux environments for maximum uptime."
  },
  {
    icon: <img src={leadershipIcon} alt="Engineering Leadership & Delivery" />,
    name: "Engineering Leadership",
    content: "Leading engineering workflows as Manager at TECHUNIQUEIIT. Driving code reviews, sprint planning, architectural decisions, and mentoring developers to deliver production-ready software on schedule."
  },
  {
    icon: <img src={uiUxIcon} alt="UI/UX & Frontend Performance" />,
    name: "UI/UX & Modern Frontend",
    content: "Crafting modern, accessible, and responsive user interfaces with TailwindCSS and Material UI. Focusing on sub-second load times, cross-device responsiveness, and intuitive user experiences."
  },
];

function Services() {
  return (
    <TrackVisibility once>
      <div className="tech-chips-for-services">
        {servicesData.map((skill, index) => (
          <div key={index} className="tech-chip-for-service">
            <i style={{ color: skill.color }}>
              {skill.icon}
            </i>
            <h3>{skill.name}</h3>
            <p>{skill.content}</p>
          </div>
        ))}
      </div>
    </TrackVisibility>
  );
}

export default Services;
